import _defineProperty from "/home/runner/work/stjude.cloud/stjude.cloud/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/stjude.cloud/stjude.cloud/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from "react";
import { Navbar as BSNavbar, Nav, Dropdown, Button, Container } from "react-bootstrap";
import MegaMenu from "./MegaMenu";

function Navbar(_ref) {
  var _linkProps;

  var children = _ref.children,
      portalConfig = _ref.portalConfig,
      loginConfig = _ref.loginConfig,
      userDropdownConfig = _ref.userDropdownConfig;
  var Link = "a"; // Force react-bootstrap to render the dropdown markdown so CSS can animate
  // the slide on toggle. After setting `show`, immediately unset to allow
  // dropdowns to function normally and independently.

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  React.useEffect(function () {
    setShow(null);
  }, []);
  var linkProps = (_linkProps = {}, _defineProperty(_linkProps, Link === "a" ? "href" : "to", portalConfig.link), _defineProperty(_linkProps, "children", portalConfig.title), _defineProperty(_linkProps, "className", "portal-title"), _linkProps);
  var portalElement = /*#__PURE__*/React.createElement(Link, linkProps);
  var loginButton;

  if (loginConfig && loginConfig.show) {
    var loginButtonProps = _defineProperty({}, Link === "a" ? "href" : "to", loginConfig.loginLink);

    loginButton = /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement(Button, _extends({
      as: Link,
      variant: "outline-light",
      className: "login-btn align-items-center"
    }, loginButtonProps), loginConfig.loginButtonMessage || "Sign in"));
  }

  var userDropdown;

  if (userDropdownConfig && userDropdownConfig.show) {
    userDropdown = /*#__PURE__*/React.createElement(Dropdown, {
      className: "user-dropdown",
      title: "User Info",
      align: "end"
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      as: Nav.Link,
      className: "profile-dropdown-toggle"
    }, /*#__PURE__*/React.createElement("span", {
      className: "user-icon",
      alt: "Account Information"
    })), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "profile-dropdown-menu",
      show: show
    }, /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, userDropdownConfig.additionalItems, userDropdownConfig.logoutLink && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Dropdown.Item, {
      as: Link,
      to: userDropdownConfig.logoutLink
    }, userDropdownConfig.logoutMessage || "Sign out")))));
  }

  return /*#__PURE__*/React.createElement("header", {
    className: "sjc-omnibar"
  }, /*#__PURE__*/React.createElement(BSNavbar, {
    variant: ""
  }, /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(BSNavbar.Brand, {
    href: "https://stjude.cloud",
    title: "St. Jude Cloud",
    alt: "St. Jude Cloud"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo"
  })), /*#__PURE__*/React.createElement("a", {
    className: "sjc-title",
    href: "https://stjude.cloud",
    title: "St. Jude Cloud"
  }, "St. Jude Cloud"), portalElement, /*#__PURE__*/React.createElement(Nav, {
    className: "global-icons",
    as: "ul"
  }, children, loginButton, userDropdown, /*#__PURE__*/React.createElement(Dropdown, {
    className: "mega-dropdown",
    title: "St. Jude Cloud Mega Menu"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    as: Nav.Link,
    className: "profile-dropdown-toggle"
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-menu-icon",
    alt: "Menu"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "mega-dropdown-menu",
    show: show
  }, /*#__PURE__*/React.createElement(MegaMenu, null)))))));
}

Navbar.displayName = "St. Jude Cloud Navbar";
export default Navbar;